<template>
  <div v-if="item.date"
       class="project-end-table-cell">
    {{ formattedDate }}
  </div>
</template>

<script>
import moment from 'moment';

const DATE_FORMAT = 'DD MMM YYYY HH:mm';

export default {
  name: 'ProjectScanDateTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedDate() {
      return moment(this.item.date).format(DATE_FORMAT);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.project-end-table-cell {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--text-primary);
  /*opacity: 50%;*/
}

</style>
